/** 
* Case Studies
*
*/

const caseStudiesNav = () => {
	const csElements = document.querySelectorAll('.cs-main');
	const csNav = document.querySelector('.cs-nav');
	const csNavItem = document.querySelectorAll('.cs-nav-item');
	const csAccordionQuestion = document.querySelectorAll('.question');

	let circWidth = 27;

	const stickyCta = () => {
		let ctaContainer = document.querySelector('.case-study-cta-container');

		if (ctaContainer) {
			let ctaPanels = document.querySelectorAll('.panel-case-study');
			let csCtaMain = document.querySelector('.cs-cta-main');

			let firstPanel = ctaPanels[0];
			let firstPanelContent = firstPanel.querySelector('.panel-content');
			let firstPanelContentLeft = firstPanelContent.offsetLeft;

			ctaContainer.style.marginLeft = firstPanelContentLeft + 'px';

			let lastPanel = ctaPanels[ctaPanels.length - 1];
			let lastPanelHeight = lastPanel.offsetHeight + 56;
			csCtaMain.style.paddingBottom = lastPanelHeight + 'px';

			let ctaContainerHeight = ctaContainer.offsetHeight;
			firstPanel.style.marginTop = '-' + ctaContainerHeight + 'px';
		}
	}



	const doTitles = () => {
		let csNavItems = document.querySelectorAll('.cs-nav-item');

		let titles = bl_dataTitleArray.map((title, index) => {

			let num = index;

			csNavItems.forEach(item => {

				let itemNum = item.getAttribute('data-itemnum');
				let childWidth = 0;


				if (num == itemNum) {

					item.setAttribute('data-title', title);

					if (title) {
						item.innerHTML = "<a href='#cs-" + (num + 1) + "'>" + title + "</a>";
					} else {
						item.innerHTML = "<a href='#cs-" + (num + 1) + "'>0" + (num + 1) + "</a>";
					}
					let child = item.querySelector('a');
					childWidth = child.offsetWidth + 16;

					child.setAttribute("data-width", (childWidth));
					item.style.width = circWidth + "px";;

					// if item classlist is active then set width to child width
					if (item.classList.contains('active')) {
						item.style.width = childWidth + 'px';
					} else {
						item.style.width = circWidth + "px";;
					}

					doMouseEvents(item);
				}
			});
			return title;
		});

		return titles;
	}

	const removeNavItems = () => {
		csNavItem.forEach(item => {
			item.remove();
		});

		csNav.innerHTML = '<div class="cs-nav-item"></div>';
	}

	const detectAccordionClick = () => {
		csAccordionQuestion.forEach(accItem => {
			accItem.addEventListener('click', (e) => {
				e.preventDefault;

				setTimeout(() => {
					initElements();
				}, 200);

			});
		});
	}

	function doIdArray() {
		const csIds = [];

		csElements.forEach(element => {
			csIds.push(element.id);
		});

		let filteredIds = csIds.filter(function (el) {
			return el != '';
		});

		setTimeout(() => {
			initElements();
		}, 200);

		return filteredIds;
	}

	const doNavItems = (items) => {

		if (items && csNavItem[0]) {
			let navItems = items;
			let numItems = navItems.length;

			for (let i = 0; i < numItems; i++) {

				let clone = csNavItem[0].cloneNode(true);
				clone.setAttribute('data-id', navItems[i]);
				clone.setAttribute('data-itemnum', i)
				clone.innerHTML = "<a href='#" + navItems[i] + "'>0" + (i + 1) + "</a>";

				csNav.appendChild(clone);

				// check for loop completion
				if (i == numItems - 1) {
					doTitles();
				}

			}

			csNavItem[0].remove();
		}
	}



	const doSmoothScroll = (items) => {

		let csNavItems = document.querySelectorAll('.cs-nav-item');
		let lastItem = csNavItems.length;
		let offset;

		csNavItems.forEach(clickItem => {
			clickItem.addEventListener('click', (e) => {
				e.preventDefault();
				let id = clickItem.getAttribute('data-id');
				let element = document.getElementById(id);

				let num = parseInt(id.substring(3));

				if (num == lastItem) {
					offset = element.offsetTop - 100;
				} else {
					offset = element.offsetTop;
				}

				window.scrollTo({
					top: offset,
					behavior: 'smooth'
				})
			});
		});
	}

	const doMouseEvents = (item) => {
		item.addEventListener("mouseenter", (event) => {
			if (!item.classList.contains('active')) {
				let linkWidth = item.querySelector('a').getAttribute('data-width');
				item.style.width = linkWidth + 'px';
			}
			item.classList.add('hovering');

		});

		item.addEventListener("mouseleave", (event) => {
			if (!item.classList.contains('active')) {
				item.style.width = circWidth + "px";;
			}
			item.classList.remove('hovering');
		});

	}

	const isInView = (items) => {

		window.addEventListener('scroll', () => {

			items.forEach(item => {

				let itemTop,
					itemHeight,
					itemBottom,
					scrollTop,
					windowHeight

				itemTop = document.querySelector('#' + item).offsetTop + 80;
				itemHeight = document.querySelector('#' + item).offsetHeight - 160;
				itemBottom = itemTop + itemHeight;

				scrollTop = window.pageYOffset;
				windowHeight = window.innerHeight;

				if (itemTop < scrollTop + windowHeight && itemBottom > scrollTop) {
					let linkWidth = document.querySelector('.cs-nav-item[data-id="' + item + '"] a').getAttribute('data-width');
					document.querySelector('.cs-nav-item[data-id="' + item + '"]').style.width = linkWidth + 'px';
					document.querySelector('.cs-nav-item[data-id="' + item + '"]').classList.add('active');
					document.querySelector('.cs-nav-item[data-id="' + item + '"]').setAttribute('data-offset', itemTop);
					console.log(item);
				} else {
					if (document.querySelector('.cs-nav-item[data-id="' + item + '"]').classList.contains("hovering")) {
						console.log('has hover');
					} else {
						document.querySelector('.cs-nav-item[data-id="' + item + '"]').style.width = circWidth + "px";;
					}

					document.querySelector('.cs-nav-item[data-id="' + item + '"]').classList.remove('active');
					document.querySelector('.cs-nav-item[data-id="' + item + '"]').removeAttribute('data-offset', itemTop);
				}


			});

		}, false);
	}

	const initElements = () => {
		let items = doIdArray();
		isInView(items);
		doSmoothScroll(items);
	}

	const init = (csNav) => {
		let items = doIdArray();

		detectAccordionClick();
		doNavItems(items);
		isInView(items);
		doSmoothScroll(items);
		stickyCta();

		csNav.classList.add('loaded');


	}

	if (csElements.length > 0) {
		init(csNav);
	} else {
		return;
	}

	// re run sticky cta on window resize
	window.addEventListener('resize', stickyCta);
	stickyCta();

}

export default caseStudiesNav;
